module.exports = __webpack_public_path__ + "img/Israel.fd0ee263.gif";